import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  customerCode: Yup.string().trim().required(),
  customerType: Yup.string().trim().required(),
})

export const segmentTypeOptions = [
  { label: 'Default', value: 'default' },
  { label: 'Bespoke', value: 'bespoke' },
]
